export default __webpack_public_path__ + "static/media/bg-categories-top.3ca6b3d0.svg";